import { Store, applyMiddleware, combineReducers, createStore } from 'redux';
import {
	handleCacheStore,
	mergeWithCachedStore,
	reducers as sharedReducers,
	sagas as sharedSagas,
} from '@innovyze/stylovyze';
import libAmCommon, {
	reducerWhiteList as amReducerWhiteList,
} from '@innovyze/lib-am-common/Reducers';
import {
	moduleNamespace as mapUiNamespace,
	reducers as mapUiReducers,
	sagas as mapUiSagas,
} from '@innovyze/map-components';
import {
	reducers as mapComponentsReducers,
	sagas as mapComponentsSagas,
} from '@innovyze/inno-map';
import reducers, { reducerWhiteList } from '@Reducers';

import { all } from 'redux-saga/effects';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import libAmCommonSaga from '@innovyze/lib-am-common/Sagas';
import { moduleNamespace } from './config.store';
import rootSaga from '../sagas';
import {
	assetSchemaRootReducer,
	assetSchemaRootSaga,
} from '@innovyze/lib_asset_schema_store';

const sagaMiddleware = createSagaMiddleware();

declare global {
	interface Window {
		store: Store;
		// eslint-disable-next-line @typescript-eslint/ban-types
		Cypress: object;
	}
}

const store: Store = createStore(
	combineReducers({
		[moduleNamespace]: reducers,
		[mapUiNamespace]: mapUiReducers,
		...sharedReducers,
		...assetSchemaRootReducer,
		...mapComponentsReducers,
		libAmCommon,
	}),
	mergeWithCachedStore(),
	composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

const cacheWhitelist = [...reducerWhiteList, ...amReducerWhiteList];

store.subscribe(() => {
	const currentState = store.getState();
	handleCacheStore(currentState, cacheWhitelist);
});

const masterSaga = function* () {
	yield all([
		rootSaga(),
		sharedSagas(),
		libAmCommonSaga(),
		mapUiSagas(),
		assetSchemaRootSaga(),
		mapComponentsSagas(),
	]);
};

sagaMiddleware.run(masterSaga);

if (window.Cypress) { // eslint-disable-line
	window.store = window.store || {}; // eslint-disable-line
	window.store = store;
}

export default store;
